<template>
    <div id="comHeader">
        <img class="iconImg"
            src="../assets/icon.png"
            alt="icon">
        <p class="title"
            v-if="title!==null"
            @click="showEditTitleModal">
            {{title}}
            <i aria-hidden="true"
                class="fa fa-pencil"></i>
        </p>
        <div class="links">
            <div v-if="links.indexOf('hotkey')>-1"
                class="link hotkey"
                @click="showHotkey">
                <i class="fa fa-info"
                    aria-hidden="true"></i>
            </div>
            <div v-if="links.indexOf('list')>-1"
                class="link toListBtn"
                @click="toListPage">
                <i class="fa fa-list"
                    aria-hidden="true"></i>
            </div>
            <div class="link signOutBtn"
                @click="signOut">
                <i class="fa fa-sign-out"
                    aria-hidden="true"></i>
            </div>
            <com-modal modalType="confirm"
                modalId="signOutModal"
                title="確認登出?"
                @confirm="confirmSignOut"></com-modal>
            <com-modal modalType="input"
                modalId="editTitleModal"
                title="請輸入歌曲名稱"
                ok-title="更新"
                emptyInputAlert="歌曲名稱請勿空白"
                :defaultInput="title"
                @confirm="confirmEditTitle"></com-modal>
            <com-modal modalType="preview"
                modalId="hotkeyModal">
                <div slot="modalContent"
                    class="hotkeyIntro">
                    <div class="hotkey">
                        <div class="key">Enter</div>
                        <div class="intro">確認複製選取範圍</div>
                    </div>
                    <div class="hotkey">
                        <div class="key">ESC</div>
                        <div class="intro">離開圖片複製模式</div>
                    </div>
                    <div class="hotkey">
                        <div class="key">SPACE</div>
                        <div class="intro">播放/暫停</div>
                    </div>
                    <div class="hotkey">
                        <div class="key">
                            <i class="fa fa-caret-left"
                                aria-hidden="true"></i>
                        </div>
                        <div class="intro">上一頁</div>
                    </div>
                    <div class="hotkey">
                        <div class="key">
                            <i class="fa fa-caret-right"
                                aria-hidden="true"></i>
                        </div>
                        <div class="intro">下一頁</div>
                    </div>
                </div>
            </com-modal>
        </div>
    </div>
</template>

<script>
import router from '@/router';
import { mapActions, mapMutations, mapGetters, } from 'vuex';
import { log } from '@/js/function';
export default {
    props: {
        links: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: null,
        },
    },
    data: () => ({}),
    methods: {
        ...mapMutations(['mutationLoading']),
        ...mapActions(['actionSignOut', 'actionUpdateSingleProject']),
        signOut() {
            this.$root.$emit('show::modal', 'signOutModal');
        },
        confirmSignOut() {
            ga('send', 'event', 'signOut', this.getUser.email);
            this.mutationLoading(true);
            this.actionSignOut().then(() => {
                this.mutationLoading(false);
                router.push({
                    name: 'sign',
                });
            })
        },
        showEditTitleModal() {
            this.$root.$emit('show::modal', 'editTitleModal');
        },
        confirmEditTitle(newTitle) {
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.projectName = newTitle;
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                this.mutationLoading(false);
            })
        },
        toListPage() {
            ga('send', 'event', 'toListPage_header', this.getUser.email);
            router.push({
                name: 'list',
            });
        },
        showHotkey() {
            this.$root.$emit('show::modal', 'hotkeyModal');
        },
    },
    computed: {
        ...mapGetters(['getUser', 'getSelectProject']),
    },
    watch: {},
    beforeCreate() { },
    created() { },
    beforeMount() { },
    mounted() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
}

</script>

<style lang="scss">
@import '../style/variable.scss';
#comHeader {
    height: $headerHeight;
    background: $headerBg;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .iconImg {
        height: 100%;
        margin-top: 10px;
    }
    .title {
        font-size: 1.4rem;
        font-weight: 800;
        text-shadow: 0px 1px 2px white;
        padding: 0 20px;
        margin: 0;
        white-space: nowrap;
        text-overflow: ellipsis; // overflow: hidden;
        position: relative;
        cursor: pointer;
        &:hover {
            i {
                display: block;
            }
        }
        i {
            display: none;
            position: absolute;
            right: 0;
            top: 6px;
            font-size: 1rem;
            &:hover {
                color: gray;
            }
        }
    }
    .links {
        display: flex;
        .link {
            @include square($headerHeight);
            cursor: pointer;
            font-size: 1.5rem;
            &:hover {
                color: white;
                background: rgba(255, 255, 255, .2);
                transition: all .5s ease;
            }
        }
    }
    .hotkeyIntro {
        text-align: center;
        .hotkey {
            display: flex;
            justify-content: center;
            align-content: center;
            .key {
                background: black;
                color: white;
                margin: 10px;
                width: 80px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 5px;
            }
            .intro {
                width: 180px;
                height: 40px;
                line-height: 40px;
                margin: 10px;
                text-align: left;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// com-header.vue?2de64b42